import React from 'react';
import { formatCurrency } from '../../../../../utils/helpers';
import './styles/service-details/ServiceDetails.css';

const ServiceDetails = ({ appointment }) => {
  console.log('Service Details - Data:', {
    service: appointment.serviceName,
    serviceData: appointment.serviceData,
    addons: appointment.selectedAddons || appointment.addons
  });

  // Get addons from all possible sources
  const addons = appointment.selectedAddons || appointment.addons || [];

  return (
    <section className="appt-service-details-section">
      <header className="appt-service-details-header">
        <h2 className="appt-service-details-title">Service Details</h2>
        <p className="appt-service-details-subtitle">Included in this appointment</p>
      </header>

      <div className="appt-service-details-list">
        <article className="appt-service-details-item appt-service-details-item-primary">
          <div className="appt-service-details-item-main">
            <span className="appt-service-details-badge">Service</span>
            <p className="appt-service-details-name">{appointment.serviceName}</p>
          </div>
          {appointment.duration > 0 && (
            <p className="appt-service-details-duration">{appointment.duration} min</p>
          )}
          {appointment.serviceData?.description && (
            <p className="appt-service-details-description">{appointment.serviceData.description}</p>
          )}
        </article>

        {addons?.map((addon, index) => (
          <article key={`addon-${index}`} className="appt-service-details-item">
            <div className="appt-service-details-item-main">
              <span className="appt-service-details-badge appt-service-details-badge-addon">Add-on</span>
              <p className="appt-service-details-name">{addon.name}</p>
            </div>
            {addon.duration > 0 && (
              <p className="appt-service-details-duration">{addon.duration} min</p>
            )}
            {addon.price > 0 && (
              <p className="appt-service-details-price">{formatCurrency(addon.price)}</p>
            )}
          </article>
        ))}
      </div>
    </section>
  );
};

export default ServiceDetails; 